import { createVar } from '~/theme';

export const iconSize = createVar('stepNumber-iconSize');
